import { useMemo } from 'react'

import type { ComparableField, ComparableValue } from '../types/diffing'
import { useTemplateContext } from './templateContext'

export const useComparableField = <T extends ComparableField>(
  path: string,
): ComparableValue<T> => {
  const { fieldValueForPath } = useTemplateContext()
  const previous = useMemo(
    () => fieldValueForPath<T>(path, 'previous'),
    [path, fieldValueForPath],
  )

  const current = useMemo(
    () => fieldValueForPath<T>(path, 'unflattened'),
    [path, fieldValueForPath],
  )

  const inherited = useMemo(
    () => fieldValueForPath<T>(path, 'inherited'),
    [path, fieldValueForPath],
  )

  return useMemo(
    () => ({
      current,
      previous,
      inherited,
    }),
    [current, inherited, previous],
  )
}
